import { useEffect, useState } from "react";

export function usePCCSession() {
  const [pccUserId, setPccUserId] = useState(null);
  const [orgUuid, setOrgUuid] = useState(null);
  const [token, setToken] = useState(null);
  const [tokenExpiresAt, setTokenExpiresAt] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);

  // Back-compat raw arrays you were already using
  const [noteTypes, setNoteTypes] = useState([]);
  const [facilities, setFacilities] = useState([]);

  // New: UI-friendly options with ids-as-strings
  const [noteTypeOptions, setNoteTypeOptions] = useState([]);
  const [facilitiesOptions, setFacilitiesOptions] = useState([]);

  // New: keep the first-facility as a soft default only (not a forced selection)
  const [defaultFacId, setDefaultFacId] = useState(null);

  // 🔴 NEW: PCC quota exceeded flag (from sessionStorage, set by PCCCallbackHandler)
  const [quotaExceeded, setQuotaExceeded] = useState(false);

  useEffect(() => {
    const accessToken = sessionStorage.getItem("pcc_accessToken");
    const orgUuid = sessionStorage.getItem("pcc_orgUuid");
    const userId = sessionStorage.getItem("pcc_userId");
    const refreshToken = sessionStorage.getItem("pcc_refreshToken");
    const expiresAt = sessionStorage.getItem("pcc_tokenExpiresAt");

    // Back-compat caches
    const cachedNoteTypes = JSON.parse(
      sessionStorage.getItem("pcc_noteTypes") || "[]"
    );
    const cachedFacilities = JSON.parse(
      sessionStorage.getItem("pcc_facilities") || "[]"
    );

    // New options (preferred)
    const cachedNoteTypeOptions = JSON.parse(
      sessionStorage.getItem("pcc_noteTypeOptions") || "[]"
    );
    const cachedFacilitiesOptions = JSON.parse(
      sessionStorage.getItem("pcc_facilitiesOptions") || "[]"
    );

    const softDefaultFacId =
      sessionStorage.getItem("pcc_defaultFacId") ||
      sessionStorage.getItem("pcc_facId");

    setPccUserId(userId);
    setOrgUuid(orgUuid);
    setToken(accessToken);
    setTokenExpiresAt(expiresAt ? parseInt(expiresAt) : null);
    setRefreshToken(refreshToken);

    setNoteTypes(cachedNoteTypes);
    setFacilities(cachedFacilities);

    setNoteTypeOptions(
      Array.isArray(cachedNoteTypeOptions) ? cachedNoteTypeOptions : []
    );
    setFacilitiesOptions(
      Array.isArray(cachedFacilitiesOptions) ? cachedFacilitiesOptions : []
    );

    setDefaultFacId(softDefaultFacId ? String(softDefaultFacId) : null);

    // 🔴 NEW: read quota flag
    const quotaFlag =
      sessionStorage.getItem("pcc_quota_exceeded") === "1";
    setQuotaExceeded(quotaFlag);
  }, []);

  return {
    pccUserId,
    orgUuid,
    token,
    tokenExpiresAt,
    refreshToken,

    // Back-compat fields (still provided)
    noteTypes,
    facilities,

    // Preferred UI-friendly options
    noteTypeOptions,
    facilitiesOptions,

    // Soft default only; do not force-select
    defaultFacId,

    // 🔴 NEW: use this to disable PCC actions / show messaging
    quotaExceeded,
  };
}
